import { createAction } from 'redux-actions';

export const setFavourites = createAction('SET_FAVOURITES');

export const deleteFavourites = createAction('DELETE_FAVOURITES');
